import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { StandardApiResponse } from '@app/interfaces/standard-api-response';
import { PermissionsModel, RolePermissionsModel } from '@app/models/system-settings';

@Injectable()
export class SiteClaimsService {
	endpointBase = '/api/siteClaims';

	constructor(private readonly http: HttpClient) {}

	public getSiteClaims(): Observable<any> {
		return this.http.get(this.endpointBase);
	}

	public getAccess(): Observable<StandardApiResponse<PermissionsModel>> {
		return this.http.get<StandardApiResponse<PermissionsModel>>(this.endpointBase + '/permissions');
	}

	public getRolePermissions(): Observable<RolePermissionsModel> {
		return this.http.get<RolePermissionsModel>(this.endpointBase + '/role-permissions');
	}

	public updateActiveFlag(claims: any): Observable<any> {
		return this.http.put(this.endpointBase + '/updateActiveFlag', claims);
	}

	public getAccessibleModuleNames(): Observable<any> {
		return this.http.get(this.endpointBase + '/getAccessibleModuleNames');
	}
}
